module.exports = __webpack_public_path__ + "static/img/作品83.bbf5591.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/作品83.png
// module id = 6/iV
// module chunks = 1